import { ReactNode } from 'react'
import { TableCell } from '../../components/ui/table'

enum TableCellBorder {
	X = 'border-x',
	Y = 'border-y',
	ALL = 'border',
	BOTTOM = 'border-b',
	NONE = '',
}

interface TableCellProps {
	children: ReactNode
	border?: 'x' | 'y' | 'all' | 'none' | 'bottom'
}

const borderMap: Map<string, TableCellBorder> = new Map([
	['x', TableCellBorder.X],
	['y', TableCellBorder.Y],
	['all', TableCellBorder.ALL],
	['none', TableCellBorder.NONE],
	['bottom', TableCellBorder.BOTTOM],
])

export const TableDataCell = ({ children, border }: TableCellProps) => {
	const selectedBorder = borderMap.get(border ?? 'all') || TableCellBorder.ALL

	return (
		<TableCell
			className={`px-4 py-4 font-normal text-gray-800 ${selectedBorder} border-gray-100 dark:border-white/[0.05] text-theme-sm dark:text-gray-400 whitespace-nowrap`}
		>
			{children}
		</TableCell>
	)
}

export const TableHeaderCell = ({ children, border, isText = true }: TableCellProps & { isText?: boolean }) => {
	const selectedBorder = borderMap.get(border ?? 'all') || TableCellBorder.ALL

	return (
		<TableCell isHeader className={`px-4 py-3 ${selectedBorder} border-gray-100 dark:border-white/[0.05]`}>
			{isText && (
				<div className="flex items-center justify-between cursor-pointer">
					<p className="font-medium text-gray-700 text-theme-xs dark:text-gray-400">{children}</p>
				</div>
			)}
			{!isText && children}
		</TableCell>
	)
}
